import { Item } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/ContentPages/components/item";
import { Items } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/ContentPages/components/items";
import { Base } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/ContentPages/contentPages.base";

export const ContentPages = Object.assign(Base, {
    Items: Items,
    Item: Item
});
